import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "projects min-h-screen grid place-items-center bg-green-50 py-2 px-3 relative overflow-hidden" }
const _hoisted_2 = { class: "card-container grid sm:grid-cols-1 md:grid-cols-4 gap-8" }
const _hoisted_3 = {
  class: "card-1 flex flex-col",
  "data-aos": "fade-up"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white" }, "Classified Ads", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "font-normal text-gray-700 dark:text-gray-400" }, " An immersive, user-friendly classified ad website, custom-built to cater to the needs of the bustling trucking industry. ", -1)
const _hoisted_6 = {
  class: "card-2 flex flex-col",
  "data-aos": "fade-up"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white" }, "Fleet Management ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "font-normal text-gray-700 dark:text-gray-400" }, " Designed an intuitive, information-rich admin dashboard for trucking companies to streamline their fleet management and maintenance tasks. ", -1)
const _hoisted_9 = {
  class: "card-3 flex flex-col",
  "data-aos": "fade-up"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white" }, "Trucking Safety", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "font-normal text-gray-700 dark:text-gray-400" }, " Developed a comprehensive website for a trucking safety consulting company, aiming to project their dedication towards improving safety standards within the trucking industry. ", -1)
const _hoisted_12 = {
  class: "card-3 flex flex-col",
  "data-aos": "fade-up"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white" }, "Fleetup Search", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "font-normal text-gray-700 dark:text-gray-400" }, " Fleetup Search is an application designed to allow users to search for truck services based on their truck's location and a specified radius, it simplifies maintenance, fuel services, or emergency repairs. ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute inset-0 -z-10 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("pattern", {
      id: "0787a7c5-978c-4f66-83c7-11c213f99cb7",
      width: "200",
      height: "200",
      x: "50%",
      y: "-1",
      patternUnits: "userSpaceOnUse"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M.5 200V.5H200",
        fill: "none"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("rect", {
    width: "100%",
    height: "100%",
    "stroke-width": "0",
    fill: "url(#0787a7c5-978c-4f66-83c7-11c213f99cb7)"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_card = _resolveComponent("the-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_card, {
          variant: "image",
          "img-src": require('@/assets/ad-1.png'),
          "img-alt": "ads",
          class: "flex-grow"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }, 8, ["img-src"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_the_card, {
          variant: "image",
          "img-src": require('@/assets/dash-1.png'),
          "img-alt": "dash",
          class: "flex-grow"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        }, 8, ["img-src"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_the_card, {
          variant: "image",
          "img-src": require('@/assets/s3m-1.png'),
          "img-alt": "s3m",
          class: "flex-grow"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        }, 8, ["img-src"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_the_card, {
          variant: "image",
          "img-src": require('@/assets/search-1.png'),
          "img-alt": "s3m",
          class: "flex-grow"
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        }, 8, ["img-src"])
      ])
    ]),
    _hoisted_15
  ]))
}